import React, { useCallback } from "react";
import { BasicIcon, BasicIconsType } from "@pickit/pickit-components";
import { MobileFirstPageProps } from "./types";
import "./mobileFirstPage.scss";
import { TABS_ICONS } from "pages/Home/components/Faq/types";
import { useTranslation } from "react-i18next";

const MobileFirstPage: React.FC<MobileFirstPageProps> = ({
  next,
  slots,
  account,
  earnings,
  operate,
  trips,
  roadSafety,
}) => {
  const { t } = useTranslation();
  const options = [
    {
      label: t("Account:title"),
      page: account,
      iconName: TABS_ICONS.Account,
    },
    {
      label: t("Slots:title"),
      page: slots,
      iconName: TABS_ICONS.Slots,
    },
    {
      label: t("Trips:title"),
      page: trips,
      iconName: TABS_ICONS.Trips,
    },
    {
      label: t("faq:operate"),
      page: operate,
      iconName: TABS_ICONS.Operate,
    },
    {
      label: t("Earnings:title"),
      page: earnings,
      iconName: TABS_ICONS.Earnings,
    },
    ...(roadSafety !== undefined
      ? [
          {
            label: t("RoadSafety:title"),
            page: roadSafety,
            iconName: TABS_ICONS.RoadSafety,
          },
        ]
      : []),
  ];

  const handleClick = useCallback(
    (page: string) => () => {
      next(page);
    },
    [next]
  );

  return (
    <div className="optionsContainer">
      {options.map((option) => (
        <button onClick={handleClick(option.page)} className="option">
          <BasicIcon name={option.iconName as BasicIconsType} clickable />
          <p>{option.label}</p>
        </button>
      ))}
    </div>
  );
};

export default MobileFirstPage;
